<template>
    <div ref="content">
        <top-bar class="shadow" />

        <div class="d-flex">
            <b-collapse v-if="sideBar.show" v-model="sideBar.toggle" id="sidebar-collapse"  class="position-relative shadow-right">
                <side-bar />
            </b-collapse>

            <div :class="{'content-wrapper': true, 'overflow-hidden': contentOverflow}">
                <div class="pb-10 bg-yellow-gradient text-white" v-if="!hideGradient">
                    <div class="container-fluid d-flex align-items-center justify-content-between">
                        <div class="pt-2 d-flex">
                            <i :class="'fas fa-2x m-2 '+icon" />
                            <h1>{{ title }}</h1>
                        </div>
                        <slot name="headerRight" />
                    </div>
                    <div class="ml-5 mb-3">{{ subtitle }}</div>
                </div>

                <slot />
                <slot name="LayoutGradientAppend" />

            </div>

            <ScrollToTop />
        </div>
        <footer-dashboard />
    </div>
</template>

<script>
    import ScrollToTop from "@/components/ScrollToTop";
    import SideBar from '@/components/SideBar'
    import TopBar from '@/components/TopBar'
    import FooterDashboard from '@/components/FooterDashboard'
    import Loading from '@/components/Loading'
    export default {
        name: "LayoutGradient",
        components: {
          ScrollToTop,
            SideBar,
            TopBar,
            FooterDashboard,
            Loading
        },
        props: {
            showSideBar:{
                type: Boolean,
                default: true
            },
            title:{
                type: String,
                default: ''
            },
            icon:{
                type: String,
                default: 'fa-table'
            },
            subtitle:{
                type: String,
                default: ''
            },
            hideGradient: {
                type: Boolean,
                default: false
            },
            contentOverflow: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                sideBar: {
                    show: true,
                    toggle: false
                },
            }
        },
        mounted() {
            if (!this.showSideBar) this.sideBar.show = false
            if (this.$refs.content.clientWidth >= 990) this.sideBar.toggle = true
        }
    }
</script>

<style lang="scss" scoped>
    .content-wrapper{
        flex: 3;
        background-color: #f8f9fc;
    }
    .bg-transparent {
        background-color: transparent !important;
    }
    .bg-yellow-gradient {
        background-color: #f9b112;
        background-image: linear-gradient(135deg, #f9b112 0%, rgba(255, 255, 255, 0.8) 100%);
      .container-fluid{
        @media (max-width: 600px) {
          flex-direction: column !important;
          h1{
            font-size: 2rem;
            margin: 0.5rem;
          }
        }
      }
    }
    .pb-10, .py-10 {
        padding-bottom: 6rem !important;
    }
    .mt-n10, .my-n10 {
        margin-top: -6rem !important;
    }
    .mt-n5, .my-n5 {
        padding: -3rem!important;
    }
    .shadow-right {
        box-shadow: 0.15rem 0 1.75rem 0 rgba(31, 45, 65, 0.15);
    }
</style>
